import DialogContent from "@material-ui/core/DialogContent";
import { PassProps } from "components/_helpers/PassProps";
import { GridForm, GridInput } from "components/GridForm";
import { NumberInputEx } from "components/inputs";
import { CommodityInput } from "components/inputs/CommodityInput";
import { CoolerTypeSelect } from "components/inputs/CoolerTypeSelect";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { PalletType } from "entities/PalletType";
import React from "react";
import { TextInput, maxLength, required, useTranslate } from "react-admin";
import { validatePositiveNumber } from "utils/validation/general";

export const AddEditProductArticleFieldBody = ({ form, ...rest }) => {
	const translate = useTranslate();

	const validateContainsOnlyDigits = (value) => {
		if (value && !/^\d+$/.test(value)) {
			return translate("osfc.messages.validation.validateContainsOnlyDigits");
		}
		return undefined;
	};

	return (
		<PassProps
			component={DialogContent}
			childPropKeys={["resource", "record"]}
			resource="product-articles"
			{...rest}
		>
			<GridForm>
				<GridInput
					md={6}
					component={TextInput}
					source="product_number"
					validate={[required(), maxLength(64)]}
				/>
				<GridInput
					md={6}
					component={TextInput}
					source="product_name"
					validate={[required(), maxLength(64)]}
				/>
				<GridInput
					md={6}
					component={NumberInputEx}
					type="float"
					source="default_box_weight"
					digitsCount={2}
					step={0.5}
					validate={[validatePositiveNumber(translate)]}
				/>
				<GridInput
					md={6}
					source="commodity_id"
					component={CommodityInput}
					validate={[required()]}
				/>
				<GridInput md={4}>
					<CoolerTypeSelect source="default_temperature" />
				</GridInput>
				<GridInput
					md={4}
					component={SelectEnumInput}
					source="default_pallet_type"
					enumName="pallet_type"
					enumObj={PalletType}
				/>
				<GridInput
					md={4}
					component={TextInput}
					source="default_unit_per_pallets"
					validate={[maxLength(10000), validateContainsOnlyDigits]}
				/>
			</GridForm>
		</PassProps>
	);
};
